import { useMemo, useCallback } from 'react';
import { getPluginsLink, getWebAppLink } from '../../../utils/links.es.js';
import { usePricingLink } from './usePricingLink.es.js';
import { NavItems } from '../../../enums/NavItems.es.js';
import { useNavBarContext } from '../../../contexts/NavBarProvider/NavBarContext.es.js';
import { useNavBarLocation } from '../../../contexts/NavBarProvider/NavBarProvider.es.js';
import { getSamplesLink } from '@landr/core';

function useIsCurrentLink() {
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env;
  var location = useNavBarLocation();
  var pricingLink = usePricingLink();
  var url = useMemo(function () {
    var host = location.host,
      protocol = location.protocol,
      pathname = location.pathname;
    if (!host || !protocol || !pathname) {
      return '';
    }
    return "".concat(protocol, "//").concat(host).concat(pathname);
  }, [location]);
  var isCurrentLink = useCallback(function (navItem) {
    switch (navItem) {
      case NavItems.Samples:
        return url.startsWith(getSamplesLink(env));
      case NavItems.Mastering:
        return url.startsWith(getWebAppLink(env, '/library'));
      case NavItems.Distribution:
        return url.startsWith(getWebAppLink(env, '/releases'));
      case NavItems.Plugins:
        return url.startsWith(getPluginsLink(env));
      case NavItems.Pricing:
        return url.startsWith(pricingLink);
      default:
        return false;
    }
  }, [url, pricingLink, env]);
  return isCurrentLink;
}

export { useIsCurrentLink };
